/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import { HttpBase } from '@/api/base/HttpBase';

class Ce extends HttpBase {
    constructor() {
        super();
        this.baseUrl += '/ce';
    }
}

export default new Ce();
export { Ce };
